﻿import { openPanel } from "@/sharedComponents/Panel";
window.addEventListener("load", () => {
  openPanel("login-panel");
});